module.exports = __webpack_public_path__ + "static/img/lucky_title.4e9a4ce.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/lucky_title.png
// module id = 566
// module chunks = 1